// src/components/chip/chip.tsx
import { tv } from "tailwind-variants";
import { jsx, jsxs } from "react/jsx-runtime";
var chip = tv({
  base: "flex items-center w-fit h-fit rounded-full font-semibold",
  variants: {
    color: {
      accent: "bg-accent-extraSoft",
      caution: "bg-caution-extraSoft",
      neutral: "bg-neutral-200",
      positive: "bg-positive-soft",
      negative: "bg-primary-soft",
      inverted: "bg-neutral-600 text-neutral-0",
      transparent: "bg-transparent border border-neutral-20"
    },
    size: {
      sm: "py-0.5 text-xs",
      md: "py-1 text-sm",
      lg: "py-1.5 text-base"
    },
    hasLeadingElement: {
      true: "pl-2 pr-3",
      false: "pl-2 pr-2"
    }
  },
  defaultVariants: {
    color: "transparent",
    size: "md",
    hasLeadingElement: false
  }
});
var Chip = ({
  children,
  color,
  size,
  leadingElement,
  className,
  ...rest
}) => {
  const chipClasses = chip({
    className,
    color,
    size,
    hasLeadingElement: Boolean(leadingElement)
  });
  return /* @__PURE__ */ jsxs("span", { className: chipClasses, ...rest, children: [
    leadingElement && /* @__PURE__ */ jsx("span", { className: "flex items-center w-4 h-4 mr-1", children: leadingElement }),
    children
  ] });
};
export {
  Chip
};
